import { ErrorResponse, SuccessResponse } from 'types/api';
import {
	ChangelogSchema,
	DeploymentType,
} from 'types/api/changelog/getChangelogByVersion';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getChangelogByVersion = async (
	_versionId: string,
	_deployment_type?: DeploymentType,
): Promise<SuccessResponse<ChangelogSchema> | ErrorResponse> => ({
	statusCode: 200,
	error: null,
	message: 'OK',
	payload: null as unknown as ChangelogSchema,
});

export default getChangelogByVersion;
